import { render, staticRenderFns } from "./BCXAbsoluteTransition.vue?vue&type=template&id=42e29d6c"
import script from "./BCXAbsoluteTransition.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXAbsoluteTransition.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXAbsoluteTransition.vue?vue&type=style&index=0&id=42e29d6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports